import BaseService from "./BaseService";

export default class AgentContactService extends BaseService {
  static endPoint = "agent-inquiry";
}
